// src/pages/SignUp.jsx
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import FancyButton from '../../components/ui/fancyButton';
import { supabase } from '../../services/supabaseClient/supabaseClient';
import AuthLayout from '../../components/Auth/authLayout';
import { createDefaultProfile } from '../../services/supabaseClient/createDefaultProfile';

const SignUp = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSignup = async () => {
    // eslint-disable-next-line no-console
    console.log('Signup flow started for email:', email);
    // First check if the email exists in our users table
    const { error, data } = await supabase.auth.signUp({ email, password });
    if (!error && data?.user?.id) {
      await createDefaultProfile(data.user.id);
    }
    if (error) {
      // eslint-disable-next-line no-console
      console.error('Supabase signup error:', error);

      if (
        error.status &&
        error.message &&
        error.message.toLowerCase().includes('user already registered')
      ) {
        setMessage('It looks like this email is already registered. Try logging in instead?');
      } else {
        setMessage(error.message);
      }
      return;
    }
    //console.log('Signup flow successful:', data);
    setMessage('Check your email for a verification link.');
    navigate('/verification-sent');
  };

  return (
    <AuthLayout title="Create Account">
      <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <FancyButton variant="primary" onClick={handleSignup}>
        Sign Up
      </FancyButton>

      <div style={{ marginTop: '16px', textAlign: 'center' }}>
        <span style={{ color: '#666' }}>Already have an account? </span>
        <Link to="/login" style={{ color: '#0077B6', fontWeight: '500' }}>
          Log in
        </Link>
      </div>

      {message && <p>{message}</p>}
    </AuthLayout>
  );
};

export default SignUp;
